import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M3 10.43 8 5l5 5.42Z';
const draw24px = 'M7,14.42,12,9l5,5.42Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TriangleUpIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'triangleUp'));
TriangleUpIcon.displayName = 'TriangleUpIcon';
TriangleUpIcon.propTypes = Icon.propTypes;
TriangleUpIcon.renderIcon = props => /*#__PURE__*/React.createElement(TriangleUpIcon, props);
export default TriangleUpIcon;
//# sourceMappingURL=TriangleUpIcon.js.map